export default "__VITE_ASSET__BGxeZfmo__"